import React, { useState, useCallback, useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';
//import icons from heroicons
import { TrashIcon, PencilSquareIcon, EyeIcon, DocumentTextIcon, DocumentIcon, ListBulletIcon } from '@heroicons/react/24/outline';
import AlertContext from '../../GlobalComponents/Alert/contexts/alertContext';


//import global components
import { Modal, ModalActionConfirm, DocumentViewer, Modaldata, ListViewCard } from '../../../imports';

const Card = ({ id, data, list, setList, setCurrentIdCard, setShowModal, setValuesById, setShowModaldata, setValuesByIdListPerson, allowEdit, listByPerson, setListEducationByPerson, userCompleteCV, deleteElementCV, setActionTypeConfirmModal, title }) => {

    const [isDeleted, setIsDeleted] = useState(false);

    const alertCtx = useContext(AlertContext);
    const [modalConfirmVisible, setModalConfirmVisible] = useState(false);

    const [modalFileUser, setModalFileUser] = useState(false);

    const [modalListView, setModalListView] = useState(false);

    // ---- Estilos: compactos cuando es vista de administrador (allowEdit === true) ----
    const cardMargin = allowEdit ? "mt-4" : "mt-9";
    const cardShadow = allowEdit ? "shadow-sm hover:shadow-md hover:border-gray-300 transition-all duration-200" : "shadow-lg";
    const headerTopSpacing = allowEdit ? "mt-1 py-0.5 space-y-0.5" : "mt-6 py-1";
    const rowSpacing = allowEdit ? "px-1 py-0.5" : "m-1";
    const rowSpacingBody = allowEdit ? "px-1 py-0.5" : "p-1";
    const rowSpacingFooter = allowEdit ? "px-1 py-0.5" : "p-1";
    const sectionPadding = allowEdit ? "py-1 px-1" : "py-3 px-1";
    const headerPadding = allowEdit ? "p-1.5" : "p-2";
    const textSize = allowEdit ? "text-xs" : "text-sm";
    const iconButtonSize = allowEdit ? "h-7 px-1.5 pt-0.5 pb-0.5" : "h-9 px-2.5 pt-1 pb-2";
    const iconSize = allowEdit ? "h-5 w-5" : "h-6 w-6";

    // ---- Helper: detecta valores tipo Sí/No para pintarlos como chip ----
    const isYesNoValue = (value) => value === "Si" || value === "Sí" || value === "No";

    const renderValue = (value) => {
        if (isYesNoValue(value)) {
            const isYes = value === "Si" || value === "Sí";
            return (
                <span
                    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${isYes
                        ? "bg-emerald-100 text-emerald-700"
                        : "bg-gray-100 text-gray-500"
                        }`}
                >
                    {value}
                </span>
            );
        }
        return (
            <p
                title={value}
                className={`w-1/2 text-truncate overflow-hidden ${textSize} font-sans text-black-RS ml-1`}
            >
                {value}
            </p>
        );
    };

    const showModal = event => {
        const id = event.currentTarget.id;

        if (list[id]) {
            setValuesById(list[id])
        }

        setCurrentIdCard(id);
        setActionTypeConfirmModal("Editar");
        setShowModal(true);
    }

    const showModaldata = event => {
        const id = event.currentTarget.id;

        if (list[id]) {
            setValuesById(list[id])
        }

        setCurrentIdCard(id);
        setActionTypeConfirmModal("Ver");
        setShowModal(true);
    }


    const deleteCard = async () => {
        const idCard = id

        if (userCompleteCV === "true") {


            let keys = Object.values(data?.dataID);

            const response = await deleteElementCV(keys[0]);

            if (response.indicador == 0) {
                alertCtx.success(response.mensaje);
                setModalConfirmVisible(false);
            }
        }

        //avoid error when list only have one element
        if (list?.length !== 1) {

            let copy = [];
            copy = [...list]

            copy.splice(idCard, 1);

            setList(copy);
        } else {
            if (list) {

                const array = list.forEach((item) => {

                    list.splice(item, 1);

                });
                if (array === undefined) {
                    setList([])
                }

            }

        }




    }

    useEffect(() => {
        if (isDeleted && userCompleteCV === "false") {
            deleteCard();
        }

        return (() => {
            setIsDeleted(false);
        })
    }, [list, isDeleted])

    return (
        <>
            {/*Here we show view confirm delete modal compononent*/}
            <Modal isVisible={modalConfirmVisible} onClose={() => { setModalConfirmVisible(false) }} handleSubmit={() => null} onSaveOptions={null} showFotter={false} showCloseIcon={false}>
                <ModalActionConfirm onSaveAction={deleteCard} actionType={""} setshowConfirmModal={setModalConfirmVisible} />
            </Modal>

            {/* MODAL DOCUMENTO */}
            {modalFileUser && createPortal(
                <div className="fixed inset-0 z-[9999] bg-black/70 flex items-center justify-center p-4">

                    {/* Contenedor principal */}
                    <div className="relative w-full max-w-[95vw] h-[94vh] bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col">

                        {/* HEADER */}
                        <div className="flex items-center justify-between px-5 py-3 bg-[#2C2D3A] text-white flex-shrink-0">

                            <div className="flex items-center gap-3">
                                <DocumentIcon className="h-6 w-6" />

                                <div>
                                    <h2 className="font-bold text-lg">
                                        Documento ingresado
                                    </h2>

                                    {data?.dataForGlobalList?.fileNameValue && (
                                        <p className="text-xs text-gray-300 truncate max-w-[60vw]">
                                            {data.dataForGlobalList.fileNameValue}
                                        </p>
                                    )}
                                </div>
                            </div>

                            {/* CERRAR */}
                            <button
                                type="button"
                                onClick={() => setModalFileUser(false)}
                                className="flex items-center justify-center w-9 h-9 rounded-lg border border-red-400/40 text-red-400 hover:bg-red-500 hover:text-white transition-all duration-200"
                                title="Cerrar documento"
                            >
                                <span className="text-xl leading-none">
                                    ×
                                </span>
                            </button>

                        </div>

                        {/* CONTENIDO DEL DOCUMENTO */}
                        <div className="flex-1 min-h-0 bg-gray-100 overflow-auto p-4">

                            <div className="min-h-full w-full flex items-center justify-center">

                                {data?.dataForGlobalList?.fileExtensionValue?.startsWith('image') ? (

                                    /* IMAGEN */
                                    <div className="w-full h-full flex items-center justify-center">

                                        <div className="bg-white rounded-lg shadow-md p-2 max-w-full max-h-full">

                                            <DocumentViewer
                                                typeView="web"
                                                filePath={data?.dataForGlobalList?.filePathValue}
                                                fileName={data?.dataForGlobalList?.fileNameValue}
                                                fileExtension={data?.dataForGlobalList?.fileExtensionValue}
                                            />

                                        </div>

                                    </div>

                                ) : (

                                    /* PDF */
                                    <div className="w-full min-h-full flex justify-center">

                                        <div className="bg-white shadow-md rounded-lg w-full max-w-[1000px] min-h-full">

                                            <DocumentViewer
                                                typeView="pdf"
                                                filePath={data?.dataForGlobalList?.filePathValue}
                                                fileName={data?.dataForGlobalList?.fileNameValue}
                                                fileExtension={data?.dataForGlobalList?.fileExtensionValue}
                                            />

                                        </div>

                                    </div>

                                )}

                            </div>

                        </div>

                        {/* FOOTER */}
                        <div className="flex justify-end items-center px-5 py-3 bg-white border-t border-gray-200 flex-shrink-0">

                            <button
                                type="button"
                                onClick={() => setModalFileUser(false)}
                                className="px-5 py-2 rounded-lg bg-[#2C2D3A] hover:bg-[#1f202a] text-white text-sm font-semibold transition-all duration-200"
                            >
                                Cerrar
                            </button>

                        </div>

                    </div>

                </div>,
                document.body
            )}

            {/*Here we show view list details modal compononent*/}
            <Modal isVisible={modalListView} onClose={() => { setModalListView(false) }} handleSubmit={() => null} onSaveOptions={null} showFotter={false} showCloseIcon={true} insideContainer={true}>
                <div key={data?.dataHeader[0] + 1}>
                    <ListViewCard title={title} data={data} setModalListView={setModalListView} />
                </ div>
            </Modal>

            {/*each card contains props title and data*/}
            <div className={`${cardMargin} flex flex-col h-full w-full md:w-96 rounded-lg bg-white text-left px-1 ${cardShadow} text-base text-black-RS font-sans border`}>
                <div className={`container relative items-center border-b-2 border-neutral-100 text-base ${headerPadding}`}>
                    {
                        data?.dataHeader &&
                        <div className={`${headerTopSpacing} w-full font-sans left-0 ${!allowEdit || data?.dataHeader?.Proyecto || data?.dataHeader?.Empresa ? "pr-8" : ""}`}>
                            {
                                Object.keys(data?.dataHeader).map((key, i) => {
                                    return (
                                        <div className={`flex flex-row w-full ${rowSpacing}`} key={i}>
                                            <h1 className={`w-1/2 text-bold font-bold text-black-RS ${textSize}`}>{key}: </h1>
                                            <p title={data?.dataHeader[key]} className={`w-1/2 text-truncate hover:text-ellipsis overflow-hidden ${textSize} font-sans text-black-RS ml-1`}> {data?.dataHeader[key]}</p>
                                        </div>
                                    )
                                })}
                        </div>
                    }
                    {/* En modo admin, el ícono de documento se movió al footer (junto a Cursando/Trabaja actualmente) */}
                    <div className="absolute inset-y-0 right-0 mx-8 mt-1">
                        {!allowEdit && data?.dataForGlobalList?.fileExtensionValue ?
                            <button
                                id={id}
                                type="button"
                                onClick={() => setModalFileUser(!modalFileUser)}
                                className={`rounded ${iconButtonSize} text-sm font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out hover:bg-primary-600 hover:-translate-y-1`}>
                                <DocumentTextIcon className={`${iconSize} text-grayDark-RS`} />
                            </button> : null}

                        {data?.dataHeader.Proyecto || data?.dataHeader.Empresa ?
                            <button
                                id={id}
                                type="button"
                                onClick={() => setModalListView(true)}
                                className={`rounded ${iconButtonSize} text-sm font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out hover:bg-primary-600 hover:-translate-y-1`}>
                                <ListBulletIcon className={`${iconSize} text-grayDark-RS`} />
                            </button> : null}

                        {/* Solo mostrar los botones de editar y borrar si allowEdit es falso */}
                        {!allowEdit && (
                            <>
                                <button
                                    id={id}
                                    type="button"
                                    onClick={showModal}
                                    className={`rounded ${iconButtonSize} text-sm font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out hover:bg-primary-600 hover:-translate-y-1`}>
                                    <PencilSquareIcon className={`${iconSize} text-grayDark-RS`} />
                                </button>

                                <button
                                    id={id}
                                    type="button"
                                    onClick={() => { setIsDeleted(true); if (userCompleteCV === "true") { setModalConfirmVisible(true); } }}
                                    className={`rounded ${iconButtonSize} text-sm font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out hover:bg-primary-600 hover:-translate-y-1`}>
                                    <TrashIcon className={`${iconSize} text-red-RS`} />
                                </button>
                            </>
                        )}
                    </div>
                </div>
                <div className={`${headerPadding} flex-1`}>
                    {
                        data?.dataBody &&
                        <div className="font-sans left-0 w-full ">
                            {
                                Object.keys(data?.dataBody).map((key, i) => {
                                    return (
                                        <div className={`flex flex-row w-full ${rowSpacingBody}`} key={i}>
                                            <h1 className={`w-1/2 text-bold font-bold text-black-RS ${textSize}`}>{key}: </h1>
                                            {renderValue(data?.dataBody[key])}
                                        </div>
                                    )
                                })}
                        </div>
                    }
                </div>
                <div className={`border-t-2 border-neutral-100 ${sectionPadding} dark:border-neutral-600 dark:text-neutral-50 mt-auto`}>
                    {
                        data?.dataFooter &&
                        <div className="font-sans left-0 w-full">
                            {
                                Object.keys(data?.dataFooter).map((key, i) => {
                                    return (
                                        <div className={`flex flex-row w-full items-center justify-between ${rowSpacingFooter}`} key={i}>
                                            <div className="flex items-center">
                                                <h1 className={`text-bold font-bold text-black-RS ${textSize}`}>{key}:</h1>
                                                <div className="ml-1">
                                                    {renderValue(data?.dataFooter[key])}
                                                </div>
                                            </div>

                                            {/* Ícono de documento en admin: al lado del footer, no estorba el header */}
                                            {allowEdit && data?.dataForGlobalList?.fileExtensionValue ?
                                                <button
                                                    id={id}
                                                    type="button"
                                                    onClick={() => setModalFileUser(!modalFileUser)}
                                                    className="rounded h-7 px-1.5 pt-0.5 pb-0.5 text-sm font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out hover:bg-primary-600">
                                                    <DocumentTextIcon className="h-5 w-5 text-grayDark-RS" />
                                                </button> : null}
                                        </div>
                                    )
                                })}
                        </div>

                    }
                </div>
            </div>

        </>
    )
}

export default Card;